export default [
    {
      path: '/admin/finance/bank-profiles',
      name: 'bank-profile',
      meta: { requiresAuth: true },
      component: () => import('@/pages/finance/bank-profile/index.vue')
    },
  ]
